import { useMutation } from '@tanstack/react-query';
import { IOperationResultNoValue } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidatePhoneNumberUserQuery } from './usePhoneNumberUserQuery';

export function usePhoneNumberCallForwardingMutation({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: () => void;
	onError?: (error: IOperationResultNoValue) => void;
	onSettled?: () => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id, number }: { id: string; number: string }) => {
			return userSession.webServiceHelper.callAsync(`phoneNumber/${id}/callForwardingNumber`, 'PUT', {
				number,
			});
		},
		onSuccess,
		onError,
		onSettled: () => {
			invalidatePhoneNumberUserQuery();
			onSettled?.();
		},
	});
}
